import React from 'react';
import svgPaths from "../../imports/svg-20eb3x2v2w.ts";

export function TwitterIcon({ className }: { className?: string }) {
  return (
    <div className={className}>
      <svg className="block w-full h-full" fill="none" viewBox="0 0 40 40">
        <path d={svgPaths.p3547f100} stroke="black" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" />
      </svg>
    </div>
  );
}

export function YoutubeIcon({ className }: { className?: string }) {
  return (
    <div className={className}>
      <svg className="block w-full h-full" fill="none" viewBox="0 0 40 40">
        <path d={svgPaths.p36758b00} stroke="black" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" />
        <path d={svgPaths.p28273500} stroke="black" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" />
      </svg>
    </div>
  );
}

export function InstagramIcon({ className }: { className?: string }) {
  return (
    <div className={className}>
      <svg className="block w-full h-full" fill="none" viewBox="0 0 40 40">
        <path d={svgPaths.p3b19a200} stroke="black" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" />
        <path d={svgPaths.p122af600} stroke="black" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" />
        <path d="M28 12H28.0137" stroke="black" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" />
      </svg>
    </div>
  );
}

export function SnapchatIcon({ className }: { className?: string }) {
  return (
    <div className={className}>
      <svg className="block w-full h-full" fill="none" viewBox="0 0 36.57 36.57">
        <path d={svgPaths.p11fb9300} stroke="black" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" />
      </svg>
    </div>
  );
}

export function LogoLarge({ className }: { className?: string }) {
  return (
    <div className={className}>
      <svg className="block w-full h-full" fill="none" viewBox="0 0 179 103">
        <g>
          <path d={svgPaths.p17f8cc00} fill="black" />
          <path d={svgPaths.p1ba9400} fill="#ED196F" />
          <path d={svgPaths.p18096c80} fill="#ED196F" />
          <path d={svgPaths.p3760500} fill="#ED196F" />
          <path d={svgPaths.p22e0b600} fill="#ED196F" />
          <path d={svgPaths.p2fd12d00} fill="#ED196F" />
          <path d={svgPaths.p14dab000} fill="#ED196F" />
          <path d={svgPaths.p491d580} fill="black" />
          <path d={svgPaths.p9c2ef80} fill="black" />
          <path d={svgPaths.p10b4f300} fill="#ED196F" />
          <path d={svgPaths.p18854c0} fill="#ED196F" />
          <path d={svgPaths.p386f6e00} fill="black" />
          <path d={svgPaths.p103add00} fill="#ED196F" />
          <path d={svgPaths.p15cc5180} fill="#ED196F" />
          <path d={svgPaths.p2aeb87e0} fill="#ED196F" />
          <path d={svgPaths.p30ca900} fill="#ED196F" />
          <path d={svgPaths.p2649cf70} fill="black" />
          <path d={svgPaths.p255d600} fill="#ED196F" />
          <path d={svgPaths.p2b4ed800} fill="black" />
          <path d={svgPaths.p188b000} fill="#ED196F" />
        </g>
      </svg>
    </div>
  );
}

export function LogoSmall({ className }: { className?: string }) {
  return (
    <div className={className}>
      <svg className="block w-full h-full" fill="none" viewBox="0 0 129 74">
        <g>
          <path d={svgPaths.p2ebf8e00} fill="black" />
          <path d={svgPaths.p33480b00} fill="#ED196F" />
          <path d={svgPaths.p1eb38780} fill="#ED196F" />
          <path d={svgPaths.p39c67f00} fill="#ED196F" />
          <path d={svgPaths.p8a35700} fill="#ED196F" />
          <path d={svgPaths.p940c900} fill="#ED196F" />
          <path d={svgPaths.pfc02700} fill="#ED196F" />
          <path d={svgPaths.p256ae380} fill="black" />
          <path d={svgPaths.p29e83df0} fill="black" />
          <path d={svgPaths.p339b3f00} fill="#ED196F" />
          <path d={svgPaths.p25ac0cf0} fill="#ED196F" />
          <path d={svgPaths.p146a79c0} fill="black" />
          <path d={svgPaths.p31fefd00} fill="#ED196F" />
          <path d={svgPaths.p242d2700} fill="#ED196F" />
          <path d={svgPaths.pfcfa100} fill="#ED196F" />
          <path d={svgPaths.p19a7ab00} fill="#ED196F" />
          <path d={svgPaths.p5a0f00} fill="black" />
          <path d={svgPaths.p17d0ecf0} fill="#ED196F" />
          <path d={svgPaths.p107cfb80} fill="black" />
          <path d={svgPaths.pd6eaa00} fill="#ED196F" />
        </g>
      </svg>
    </div>
  );
}
